import { createRouter, createWebHistory } from 'vue-router'
import SearchCompany from './views/SearchCompany.vue'
import PrintPreview from './views/PrintPreview.vue'

const routes = [
    { path: '/', name: 'Home', component: SearchCompany },
    { path: '/printing', name: 'PrintPreview', component: PrintPreview, props: true },
  ]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router